export default __webpack_public_path__ + "static/media/gender.23a30668.svg";